import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { User } from '../User';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { ApiService } from '../api.service';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { AlertService } from '../alert.service';
import { HttpHeaders, HttpEventType, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { ModalDirective } from 'angular-bootstrap-md';
@Component({
  selector: 'app-extend-booking-payment-success',
  templateUrl: './extend-booking-payment-success.component.html',
  styleUrls: ['./extend-booking-payment-success.component.scss']
})
export class ExtendBookingPaymentSuccessComponent implements OnInit {
  private paymentStatus: boolean = true;
  private paymentId: String = "";
  private debugData: boolean = true;
  private user: User = new User();
  private bookingId: String = "";


  constructor(private httpClient: HttpClient, private route: ActivatedRoute, private router: Router,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private alertService: AlertService, private apiService: ApiService
  ) {
    this.route.paramMap.subscribe(
      params => {
        console.log(params);
        this.paymentId = params.get('id');
        if (this.debugData) {
          console.log("Payment Id:" + this.paymentId);
        }
        this.initCustData();
      }
    );
  }


  ngOnInit() {
  }

  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
      this.httpClient.get(urrr)
        .subscribe(
          data => this.intilizeComponent(data),
          error => this.showError(error)
        );

    } else {
      console.log("User Not Logged In. Please login!")
    }
  }

  intilizeComponent(data) {
    this.user = data;
    this.getExtendPaymentInfo(this.user.id, this.paymentId);
  } 

  showError(msg) {
    console.log("Error Found in server");
  }


  getExtendPaymentInfo(userId , paymentIdD){
    let paymentIdd = {
      id: userId,
      paymentId: paymentIdD
    }
    this.httpClient.post(this.apiService.GET_EXTEND_PAYMENT_INFO, paymentIdd)
      .subscribe((data: any) => {
        if (this.debugData == true) {
          console.log("Customer Payment API data");
          console.log(data);
        }
        if (this.debugData == true) {
          console.log("Customer Payment API data");
          console.log(data);
        }
        this.bookingId = data.bookingId;
        this.paymentStatus = data.status;
        // let statusss = data.status;
        // if (statusss == 0) {
        //   console.log("failed");
        //   this.paymentStatus == false;
        // } else {
        //   console.log("Sucess");
        //   this.paymentStatus == true;
        // }
      });
  }
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/extend-booking-payment-success/extend-booking-payment-success.component.ts